import { FocusedPageHeader } from 'src/components/accessibility';
import { SharedProps } from 'src/components/settings/create-settings-hoc';
import { useParams } from 'src/router/hooks';
import urls from 'src/sections/repository/urls';

import Breadcrumbs from './breadcrumbs';

export type Props = SharedProps;

const ConnectIframeHeader = (props: Props) => {
  const { repositoryOwner, repositorySlug } = useParams<{
    repositoryOwner: string;
    repositorySlug: string;
  }>();
  const settingsHref = urls.ui.admin(
    repositoryOwner || '',
    repositorySlug || ''
  );
  return (
    <FocusedPageHeader
      breadcrumbs={<Breadcrumbs settingsHref={settingsHref} {...props} />}
    />
  );
};

// eslint-disable-next-line import/no-default-export
export default ConnectIframeHeader;
